/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { userProfile } from "../images";

const RoomCard = ({ room }) => {
  const navigate = useNavigate();
  const handleRoomJoined = (id, name) => {
    if (room?.currentUser >= 6) {
      toast.error("Room is Full");
    } else {
       navigate(`/devicecheck/${id}`, { state: { name }, replace: true })
       sessionStorage.setItem("roomName", JSON.stringify(name));
    }
  };

  return (
    <div
      className={`vc-contain-box ${room?.currentUser >= 6 ? "room-full" : ""}`}
    >
      <div className="tb-box-1">
        <div className="tb-box-2">
          <div className="tb-box-3">
            <div className="btn-title">
              <h2>{room?.name || "Unknown Room"}</h2>
              <button
                className={`join-btn ${room?.currentUser >= 6 ? "btn-disable" : ""
                  }`}
                disabled={room?.currentUser >= 6}
                onClick={(e) => {
                  e.preventDefault();
                  handleRoomJoined(room?.id, room?.name);
                }}
              >
                <div style={{ opacity: 1 }}>
                  {room?.currentUser >= 6 ? `Full` : `Join`}
                </div>
              </button>

              {/* Display Participants */}
              {room?.participants?.length > 0 && (
                room?.participants?.map((user, index) => (
                  <div key={index} className={`box-${index + 1} user-main-box`}>
                    <div className="user-profile">
                      <img
                        src={user?.imageUrl && user?.imageUrl !== "undefined" ? user?.imageUrl : userProfile}
                        alt={user?.username || "User"}
                        draggable={false}
                      />
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoomCard;
